import { render, staticRenderFns } from "./moderation.vue?vue&type=template&id=f170a1e8&scoped=true"
import script from "./moderation.vue?vue&type=script&lang=js"
export * from "./moderation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f170a1e8",
  null
  
)

export default component.exports